<template>
  <div class="flex items-center" @click="onClick">
    <img  class="logo" src="../../../../assets/images/logoShield.png" alt="" />
  </div>
</template>
<script lang="ts" setup>
import { paths } from '@/router/paths'

const router = useRouter()

const onClick = () => {
  router.replace({ path: paths.departmentRole })
}
</script>
<style lang="scss" scoped>
.logo {
  max-width: 100%;
  height: 40px;
}
</style>
